import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((registration) => {
      // Check for updates every 60 seconds
      setInterval(() => registration.update(), 60 * 1000);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          // New SW is installed and waiting — show update prompt
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            showUpdateNotification();
          }
        });
      });
    }).catch(() => {});

    // Reload when the new SW takes control
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
}

function showUpdateNotification() {
  // Don't show if one already exists
  if (document.getElementById('sw-update-toast')) return;

  const toast = document.createElement('div');
  toast.id = 'sw-update-toast';
  toast.innerHTML = `
    <div style="
      position: fixed;
      bottom: 5rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      background: #4F46E5;
      color: white;
      padding: 12px 20px;
      border-radius: 12px;
      box-shadow: 0 8px 24px rgba(79, 70, 229, 0.3);
      display: flex;
      align-items: center;
      gap: 12px;
      font-family: 'DM Sans', system-ui, sans-serif;
      font-size: 14px;
      animation: slideUp 0.3s ease-out;
    ">
      <span>A new version is available</span>
      <button onclick="window.location.reload()" style="
        background: white;
        color: #4F46E5;
        border: none;
        padding: 6px 16px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        font-family: inherit;
      ">Refresh</button>
    </div>
    <style>
      @keyframes slideUp {
        from { opacity: 0; transform: translateX(-50%) translateY(20px); }
        to { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
    </style>
  `;
  document.body.appendChild(toast);
}
